class Stack {
  constructor () {
    this.items = []
  }

  push (item) {
    this.items.push(item)
  }

  pop () {
    if (this.isEmpty()) {
      return null
    }

    return this.items.pop()
  }

  peek () {
    return this.items[this.items.length - 1]
  }

  isEmpty () {
    return this.items.length === 0
  }

  getItems () {
    return this.items
  }
}

/* @ngInject */
function stackService () {
  const service = {
    createStack
  }
  return service

  function createStack () {
    return new Stack()
  }
}

export { stackService }
